
import { Component, Vue, Prop, Emit } from "vue-property-decorator";
// Entities
import { PreparationsFields, Status, Warehouse } from "@/entities/index";

@Component
export default class PreparationFilterBar extends Vue {
  @Prop() statuses: Array<Status> = [];
  @Prop() warehouses: Array<Warehouse> = [];

  @Emit("search") search(preparationFields: PreparationsFields): void {}
  @Emit("downloadCSV") downloadCSV(): void {}

  preparationsFields: PreparationsFields = {
    reference: "",
    recipientReference: "",
    clientNumber: "",
    status: "",
    warehouse: "",
    receptionDateBegin: "",
    receptionDateEnd: "",
    shippingDateBegin: "",
    shippingDateEnd: "",
  };

  date = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
    .toISOString()
    .substr(0, 10);

  // DATE MENUS
  menuRecepetionDateBegin = false;
  menuReceptionDateEnd = false;
  menuShippingDateBegin = false;
  menuShippingDateEnd = false;

  statusList = [
    "00-Portfolio",
    "10-Reserved Stocks",
    "20-Preparation",
    "30-Ready To Ship",
    "40-Partially Shipped",
    "50-Shipped",
  ];

  statusTranslation = [
    {
      code: "00-Portfolio",
      name: this.$t("Preparation.status.00"),
    },
    {
      code: "10-Reserved Stocks",
      name: this.$t("Preparation.status.10"),
    },
    {
      code: "20-Preparation",
      name: this.$t("Preparation.status.20"),
    },
    {
      code: "30-Ready To Ship",
      name: this.$t("Preparation.status.30"),
    },
    {
      code: "40-Partially Shipped",
      name: this.$t("Preparation.status.40"),
    },
    {
      code: "50-Shipped",
      name: this.$t("Preparation.status.50"),
    },
  ];

  onSearch(): void {
    this.search(this.preparationsFields);
  }

  clear(): void {
    const btnClear = document.getElementById("btnClear");
    btnClear?.classList.add("clicked");
    setTimeout(() => {
      btnClear?.classList.remove("clicked");
    }, 500);

    this.preparationsFields = {
      reference: "",
      recipientReference: "",
      clientNumber: "",
      status: "",
      warehouse: "",
      shippingDateBegin: "",
      shippingDateEnd: "",
      receptionDateBegin: "",
      receptionDateEnd: "",
    };
  }

  parseDate(date: string) {
    if (!date) return null;
    const [day, month, year] = date.split("/");
    return `${day}/${month}/${year}`;
  }
}
